import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ProtestoChequeService } from 'src/app/services/protesto-cheque.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarChequeComponent } from 'src/app/views/shared/modal-seleccionar-cheque/modal-seleccionar-cheque.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';

@Component({
  selector: 'app-cheques-protesto-modal-add-edit-protesto',
  templateUrl: './modal-add-edit-protesto.component.html',
  styleUrls: ['./modal-add-edit-protesto.component.scss'],
  providers: [SecurityService],
})
export class ModalAddEditProtestoComponent implements OnInit {
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // Modales
  @ViewChild('agregarProtesto', { static: true }) modalProtestoPago: ModalDirective;
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(ModalSeleccionarChequeComponent, { static: true }) modalSeleccionarCheque: ModalSeleccionarChequeComponent;

  // Form
  formData: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  private rutUsuario: number;
  clienteSeleccionado: any = null;
  chequeSeleccionado: any = null;
  isEditing: boolean = true;

  // Utils
  private log: any;
  optionsCuenta: Array<any> = [];
  CuentasCliente: any = null;
  CantidadCheque: number = 0;
  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private protestoChequeService: ProtestoChequeService,
    private depositoDocumentoService: DepositoDocumentoService
  ) {
    this.log = this.clog.log('MODAL-PROTESTO-CHEQUES');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.createForm();
    this.formChangesSubscriptions();
  }

  private createForm() {
    this.formData = this.fb.group({
      rutCliente: [null, [Validators.required]],
      nroCheque: [null, [Validators.required]],
      motivo: [null, [Validators.required]],
      nroCta: [null, []],
    });
  }

  private formChangesSubscriptions() {
    this.formData
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        if (this.isEditing) this.modalSeleccionarCliente.searchByRut(rutCliente);
      });

    this.formData
      .get('nroCheque')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroCheque: string) => {
        if (this.isEditing) this.abrirNroCuenta(nroCheque);
      });

    // this.formData
    //   .get('nroCheque')
    //   .valueChanges.pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((nroCheque: string) => {
    //     if (this.isEditing) this.modalSeleccionarCheque.searchByCodigo(this.clienteSeleccionado.rut, nroCheque);
    //   });
  }

  abrirNroCuenta(nroCheque) {
    const inputParams = this.createInputParams(nroCheque);
    this.depositoDocumentoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.CuentasCliente = registros;
      this.optionsCuenta = registros.map((nro) => ({ value: nro.numero_cuenta_cheque, label: nro.numero_cuenta_cheque, ...nro }));
      this.CantidadCheque = registros.length;
      // this.formValidatorsService.selectFirstOrDefault(this.formData.get('nroCta'), this.optionsCuenta);
      console.log('muestrame los registros', registros);
    });
  }

  OnchangeCambiarCta(nrocta) {
    console.log(nrocta);
    const cheque = this.CuentasCliente.filter((x) => x.numero_cuenta_cheque == nrocta.numero_cuenta_cheque);
    this.onChequeSeleccionado(cheque);
  }

  obtenerBancoSegunNroCuenta() {
    const nrcta = this.formData.get('nroCta').value;
    const cheque = this.CuentasCliente.filter((x) => x.numero_cuenta_cheque == nrcta);
    this.onChequeSeleccionado(cheque);
  }

  createInputParams(numero_doc) {
    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: this.clienteSeleccionado.rut,
        estado: 2,
        numero_doc,
        numero_cuenta_cheque: '',
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    };
  }

  show() {
    this.isEditing = true;
    this.reset();
    this.modalProtestoPago.show();
    this.modalSeleccionarCliente.cleanLast();
    this.modalSeleccionarCheque.cleanLast();
  }

  loadAndShow(codigo) {
    this.reset();
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        codigo,
      },
    };

    this.log('obtenerProtestoSegunCodigo inputParams', JSON.stringify(inputParams));

    this.protestoChequeService.obtenerProtestoSegunCodigo(inputParams, ({ mensajes, respuesta: protesto }) => {
      const ok = protesto !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.log('protesto', protesto);
      this.isEditing = false;
      this.formData.get('rutCliente').setValue(this.rutService.AgregarDV(protesto.cliente_proveedor_rut));
      this.clienteSeleccionado = {};
      this.clienteSeleccionado.nombre = protesto.cliente_proveedor_nombre;
      this.formData.get('nroCheque').setValue(protesto.numero_doc);
      this.chequeSeleccionado = {};
      this.chequeSeleccionado.cliente_proveedor_rut = protesto.cliente_proveedor_rut;
      this.chequeSeleccionado.banco_codigo = protesto.banco_codigo;
      this.chequeSeleccionado.banco_nombre_origen = protesto.nombre_banco;
      this.chequeSeleccionado.fecha_ingreso = protesto.fecha_registro;
      this.chequeSeleccionado.fecha_protesto = protesto.fecha_protesto;
      this.chequeSeleccionado.monto = protesto.monto;
      this.formData.get('motivo').setValue(protesto.motivo);
      this.modalProtestoPago.show();
    });
  }

  hide() {
    this.modalProtestoPago.hide();
  }

  reset() {
    this.formValidatorsService.reset(this.formData);
    this.clienteSeleccionado = null;
    this.chequeSeleccionado = null;
    this.optionsCuenta = [];
  }

  openModalSeleccionarClientes() {
    this.modalSeleccionarCliente.show();
  }

  onClienteSeleccionado({ data }) {
    this.chequeSeleccionado = null;
    this.formData.get('nroCta').setValue(null);
    this.clienteSeleccionado = data;
    this.formData.get('rutCliente').setValue(this.rutService.AgregarDV(this.clienteSeleccionado.rut));
  }

  onNotFoundCliente() {
    this.clienteSeleccionado = null;
    this.chequeSeleccionado = null;
    this.formData.get('nroCta').setValue(null);
  }

  openModalSeleccionarCheque() {
    this.modalSeleccionarCheque.show(this.clienteSeleccionado.rut);
  }

  onChequeSeleccionado(cheque) {
    this.log(cheque);
    if (cheque.length > 0) {
      this.chequeSeleccionado = null;
      this.chequeSeleccionado = cheque[0];
      this.formData.get('nroCheque').setValue(this.chequeSeleccionado.numero_doc);
    } else {
      this.optionsCuenta = [];
      this.chequeSeleccionado = null;
      this.chequeSeleccionado = cheque;
      this.formData.get('nroCheque').setValue(this.chequeSeleccionado.numero_doc);
      this.formData.get('nroCta').setValue(this.chequeSeleccionado.numero_cuenta_cheque);
    }
  }

  onNotFoundCheque() {
    if (this.chequeSeleccionado == null) {
      this.chequeSeleccionado = null;
      this.optionsCuenta = [];
    }
  }

  guardar() {
    this.formValidatorsService.validateAllFormFields(this.formData);
    if (!this.formData.valid) return;

    const inputParams = {
      entidad: {
        deposito_documento_codigo: this.chequeSeleccionado.codigo,
        motivo: this.formData.get('motivo').value,
        monto: this.chequeSeleccionado.monto,
        fecha_registro: this.chequeSeleccionado.fecha_ingreso,
        cliente_proveedor_rut: this.clienteSeleccionado.rut,
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        rut_usuario: this.rutUsuario, // TODO: Is ok?
        pago_codigo: this.chequeSeleccionado.pago_codigo,
        numero_doc: this.chequeSeleccionado.numero_doc,
        banco_codigo: this.chequeSeleccionado.banco_codigo,
        numero_cuenta: this.chequeSeleccionado.numero_cuenta_cheque,
        vendedor_codigo: this.chequeSeleccionado.vendedor_codigo,
      },
    };

    this.log(JSON.stringify(inputParams));

    this.protestoChequeService.guardarProtesto(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.toastrService.success('Operación realizada con éxito');
      this.onSuccess.emit();
      this.hide();
    });
  }

  cerrar() {
    this.optionsCuenta = [];
    this.hide();
  }
}
